import { Title } from 'app/agriculture/components/Title/Title';
import { FarmEditForm } from 'app/agriculture/routes/BackOffice/Settings/FarmEdit/components/FarmEditForm';
import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';

export function FarmEdit() {
    return (
        <BackOfficeContent>
            <Title>Farm Details</Title>
            <FarmEditForm />
        </BackOfficeContent>
    );
}
